import { AfterContentInit, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { ThemeMode } from '@raptor-fe/core';
import { ApplicationContextStore, ApplicationInsightsService, AuthService, StorageKeys, StorageService, WebLoadingService, ThemeService } from '@raptor-fe/services';
import { SidemenuComponent } from '@raptor-fe/ui';
import { menuContents } from './shared/menu-contents';

@Component({
    selector: 'marlin-web-root',
    imports: [RouterOutlet, NgClass, HeaderComponent, FooterComponent, SidemenuComponent, KENDO_DIALOGS],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss',
})
export class AppComponent implements AfterContentInit {
    protected readonly authService = inject(AuthService);
    protected readonly loadingService = inject(WebLoadingService);
    protected readonly themeService = inject(ThemeService);

    protected readonly applicationContextStore = inject(ApplicationContextStore);
    private readonly storageService = inject(StorageService);
    private readonly appInsights = inject(ApplicationInsightsService);

    protected menuItems = menuContents;

    async ngAfterContentInit(): Promise<void> {
        this.appInsights.initialize();
        const stored = await this.storageService.getString(StorageKeys.SELECTED_THEME);
        const theme: ThemeMode = stored?.value === 'dark' ? 'dark' : 'light';
        this.themeService.changeTheme(theme);
    }

    async toggleTheme(): Promise<void> {
        await this.themeService.toggleTheme();
    }
}
